<template>
  <div class="input-group-append">
    <div
      aria-haspopup="true"
      aria-expanded="true"
      type="button"
      class="border-0 btn btn-primary bg-white text-accent-black px-0"
      data-toggle="dropdown"
    >
      {{ checkRole(user.role) }}
      <span 
          class="png-icon bg-light position-relative png-icon-icons-glyph--k-chevron-down mb-1 bg-transparent mr-0"
        ></span>
  </div>
    <div class="rounded dropdown-menu dropdown-menu-right bg-white">
      <a
        href=""
        v-for="(role, index) in roles"
        :key="index"
        class="dropdown-item font-16"
        role="button"
        @click.prevent="
          userRoleChangeHandler({
            emailFromUsersList: user.email,
            newRole: role.role
          })
        "
      >
        <div
          class="item-texts d-flex justify-content-center"
          style="flex-direction: column;"
        >
          <span
            class="role-label role-label-font-wt role-label-font-wt"
          >
            {{ role.label }}
          </span>
          <span class="role-description">{{ role.description }}</span>
        </div>
      </a>
      <a
        href=""
        class="remove-btn dropdown-item font-16 text-danger"
        role="button"
        @click.prevent="userDeleteFromRoleListHandler(user.email)"
        v-if="isRemoveAccess"
      >
      {{ $resourceString["myProject.shareTray.Title.Dropdown.RemoveAccess"] }}
      </a>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: ["checkRole", "user", "roles", "isRemoveAccess"],

  computed: {
    ...mapGetters({
      getprojectUsers: "myTray/getprojectUsers"
    })
  },
  methods: {
    ...mapActions({
      userRoleChangeHandler: "myTray/userRoleChangeHandler",
      userDeleteFromRoleListHandler: "myTray/userDeleteFromRoleListHandler"
    })
  }
};
</script>
